import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { select } from '@ngxs/store';
import { IconsModule } from 'src/app/ui/icons/icons.module';
import { $intakeStatusDisplayViewModel } from '../../view-models/selectors';

@Component({
	selector: 'app-intake-status-display',
	imports: [CommonModule, IconsModule],
	templateUrl: './intake-status-display.component.html',
})
export class IntakeStatusDisplayComponent {
	public viewModel_ = select($intakeStatusDisplayViewModel);
}
